import React from 'react'

export default function Divider() {

  return (
    <div className="w-full border-gray-100 border-solid" style={{ height: 1, borderWidth: 1 }} />
  )
}